export default __webpack_public_path__ + "static/media/50.204a489b.jpeg";